import logo from "./logo.svg";
import "./App.css";
import { SessionForm } from "./SessionForm/index.js";

function App() {
  return (
    <div className="App">
      <SessionForm />
    </div>
  );
}

export default App;
